export default function AdminChattings () {
    return(
        <section>
        <h1>Admin Chats</h1>
        </section>
    )
}